import React from 'react';

const AboutPageView = (props) => {

    return(
    	<h1>About Page View</h1>
    )
}
export default AboutPageView;